import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LanguageProvider } from "./utils/Contexts/LanguageContext";
import "./i18n";
import { ThemeProvider } from "./utils/Contexts/ThemeContext";
import { UserProvider } from "./utils/Contexts/UserContext";
import { LoadingProvider } from "./utils/Contexts/LoadingContext";
import { CartProvider } from "./utils/Contexts/CartContext";
import { ConfirmProvider } from "./utils/Contexts/ConfirmContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoadingProvider>
      <UserProvider>
        <LanguageProvider>
          <ThemeProvider>
            <CartProvider>
              <ConfirmProvider>
                <App />
              </ConfirmProvider>
            </CartProvider>
          </ThemeProvider>
        </LanguageProvider>
      </UserProvider>
    </LoadingProvider>
  </React.StrictMode>
);
